import { useWalletAutoConnect } from 'modules/wallet/hooks/useWalletAutoConnect'

type Props = {
  children?: React.ReactNode
}

export function WalletAutoConnect({ children }: Props) {
  useWalletAutoConnect()
  return <>{children}</>
}
